export const EXSBPRICEGROUP_DELETE_RESET = 'EXSBPRICEGROUP_DELETE_RESET'
export const EXSBPRICEGROUP_DELETE_SET_ERROR = 'EXSBPRICEGROUP_DELETE_SET_ERROR'
export const EXSBPRICEGROUP_DELETE_SET_DELETED = 'EXSBPRICEGROUP_DELETE_SET_DELETED'
export const EXSBPRICEGROUP_DELETE_TOGGLE_LOADING = 'EXSBPRICEGROUP_DELETE_TOGGLE_LOADING'
